export enum FileSelectionType {
  All = 1,
  OwnedByMe = 2,
  SharedWithMe = 3
}

export const FILE_SELECTION_ENUM_MAP: {
  [key in FileSelectionType]: string;
} = {
  [FileSelectionType.All]: 'All',
  [FileSelectionType.OwnedByMe]: 'Owned by me',
  [FileSelectionType.SharedWithMe]: 'Shared with me'
};
